import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=0b04d889&scoped=true"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=0b04d889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b04d889",
  null
  
)

export default component.exports